import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { PagingModule } from '../../components/common/search/paging.module';
import { TermsAndConditionsModalModule } from '../../components/common/terms.and.conditions.modal/t.and.c.modal.module';
import { ValidationModule } from '../../components/common/validation/validation.module';
import { EnumSelectPipeModule } from '../../components/pipes/enumselectpipe/enumSelectPipe.module';
import { StripeTrainingComponent } from './stripe.training.component';
import { BookTrainingComponent } from './training.book.component';
import { TrainingComponent } from './training.component';
import { TrainingConfirmComponent } from './training.confirm.component';
import { TrainingDetailsComponent } from './training.details.component';
import { TrainingPaymentComponent } from './training.payment.component';
import { TrainingProcessingComponent } from './training.processing.component';

@NgModule({
    declarations: [TrainingComponent, TrainingDetailsComponent, BookTrainingComponent, TrainingPaymentComponent, StripeTrainingComponent, TrainingProcessingComponent, TrainingConfirmComponent],
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, RouterModule, PagingModule, ValidationModule, B2BAngularMaterialModule, CategoryTreeViewModule, BlockUIModule, EnumSelectPipeModule, TermsAndConditionsModalModule]
})

export class TrainingModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/training.module.ts